import React from "react";
import { Breadcrumbs } from "../../../../AbstractElements";
import GenerateForm from "../../../Common/Component/GenerateForm";
import TaskAssignerTwinTables from "../../../Common/TwinTables/TwinTable";
import { Settings } from "../../../../Constant";
import useAccessCategoryGroup from "./AccessCategoryGroup.controller";

export default function AccessCategoryGroup() {
    const {
        title,
        formFields,
        tableColumns,
        available,
        assigned,
        assignGroup,
        usassignGroup,
    } = useAccessCategoryGroup();

    return (
        <div className="mt-5 GeneralLedgerAssign">
            <Breadcrumbs parent={Settings} title={title} mainTitle={title} />
            <div className="filter-head-pane">
                <GenerateForm
                    onSubmit={undefined}
                    formFields={formFields}
                    formTitle={title}
                    listUrl={undefined}
                    onEdit={undefined}
                    editRecord={undefined}
                />
            </div>

            <br />

            <TaskAssignerTwinTables
                rightTableTitle={"Assign Group"}
                rightTable={assigned}
                rightTableColumns={tableColumns}
                rightButtonClick={(e: any) => assignGroup(e)}
                rightButtonTitle={"Assign"}
                //
                leftTableTitle={"Un Assign Group"}
                leftTable={available}
                leftTableColumns={tableColumns}
                leftButtonClick={(e: any) => usassignGroup(e)}
                leftButtonTitle={"Un Assign"}
            />
        </div>
    );
}
